import * as React from 'react';
import { IMicrositeRecipientCoachLogEntry } from '@nkr/models/index';
import { Alert, Button, Label, Modal, Well } from 'react-bootstrap';
import * as moment from 'moment';

interface IProps {
    show: boolean,
    data: IMicrositeRecipientCoachLogEntry,
    onDelete: () => void,
    onCancel: () => void
}

const ConfirmDeleteEntry: React.FunctionComponent<IProps> = (props) => {
    const logDateTime = props.data != null ? props.data.logDateTime : '';
    const content = props.data != null ? props.data.content : '';
    const isPinned = props.data != null ? props.data.isPinned : false;

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                Confirm Delete of Private Log Entry
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20 }}>Are you sure you want to delete the following entry?</div>

                {isPinned && (
                    <Alert bsStyle='warning' style={{ padding: '7.5px 15px' }}>WARNING! This is a pinned log entry.</Alert>
                )}

                <Well>
                    <div><Label bsStyle='info'>{moment(logDateTime).format("MM-DD-YYYY h:mm a")}</Label></div><br />
                    <div>{content}</div>
                </Well>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onDelete}>Yes, Delete</Button>
                <Button bsStyle='link' onClick={props.onCancel}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDeleteEntry;